var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { error } from './utils';
var PatchworkService = /** @class */ (function () {
    function PatchworkService(api) {
        this.PatchworkAPI = api;
    }
    // Patchwork CRUD
    PatchworkService.prototype.readPatchworkByAppId = function (appId, noDraft) {
        return __awaiter(this, void 0, void 0, function () {
            var url, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = "/apps/".concat(appId, "/patchwork");
                        return [4 /*yield*/, this.PatchworkAPI.get(url, { noDraft: noDraft })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        ex_1 = _a.sent();
                        error(ex_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, {}];
                }
            });
        });
    };
    PatchworkService.prototype.readPatchwork = function (patchworkId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, ex_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = "/patchworks/".concat(patchworkId);
                        return [4 /*yield*/, this.PatchworkAPI.get(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        ex_2 = _a.sent();
                        error(ex_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, {}];
                }
            });
        });
    };
    PatchworkService.prototype.postCopiedMonoPatch = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var copiedPatchworkId, patches, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        copiedPatchworkId = value.copiedPatchworkId, patches = value.patches;
                        url = "/patchworks/".concat(copiedPatchworkId, "/insert");
                        return [4 /*yield*/, this.PatchworkAPI.post(url, {
                                patches: patches,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PatchworkService.prototype.postCopiedPolyPatch = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var copiedPatchworkId, edges, patches, x, y, app, connected, url;
            return __generator(this, function (_a) {
                copiedPatchworkId = value.copiedPatchworkId, edges = value.edges, patches = value.patches, x = value.x, y = value.y, app = value.app, connected = value.connected;
                url = "/patchworks/".concat(copiedPatchworkId, "/mirror");
                return [2 /*return*/, this.PatchworkAPI.patch(url, {
                        edges: edges,
                        patches: patches,
                        x: x,
                        y: y,
                        app: app,
                        connected: connected,
                    }, false, { appId: app })];
            });
        });
    };
    PatchworkService.prototype.updatePatchwork = function (patchworkId, patchwork) {
        var url = "/patchworks/".concat(patchworkId);
        return this.PatchworkAPI.put(url, patchwork);
    };
    PatchworkService.prototype.deletePatchwork = function (patchworkId) {
        var url = "/patchworks/".concat(patchworkId);
        return this.PatchworkAPI.delete(url);
    };
    PatchworkService.prototype.createPatch = function (patchworkId, patch) {
        var url = "/patchworks/".concat(patchworkId, "/patches");
        return this.PatchworkAPI.post(url, patch);
    };
    PatchworkService.prototype.updatePatch = function (patchworkId, patchId, patch) {
        var url = "/patchworks/".concat(patchworkId, "/patches/").concat(patchId);
        return this.PatchworkAPI.put(url, patch);
    };
    PatchworkService.prototype.createNewCustomLogicWithPatch = function (appId, patchworkId, patch, inputs) {
        var url = "/patchworks/".concat(patchworkId, "/custom");
        var data = {
            app: appId,
            name: patch.name,
            x: patch.x,
            y: patch.y,
            inputs: inputs,
            settings: { toSync: true },
        };
        return this.PatchworkAPI.post(url, data);
    };
    PatchworkService.prototype.createCustomLogicPatchWithLogicPatches = function (appId, patchworkId, patchName, logicPatches, inputs, outputs) {
        if (inputs === void 0) { inputs = []; }
        if (outputs === void 0) { outputs = []; }
        var url = "/patchworks/".concat(patchworkId, "/custom");
        var patch = {
            app: appId,
            name: patchName,
            patches: logicPatches,
            outputs: outputs,
            inputs: inputs,
        };
        return this.PatchworkAPI.patch(url, patch);
    };
    PatchworkService.prototype.saveCustomLogicArgument = function (appId, patchworkId, patchId, arg) {
        if (patchworkId && patchId) {
            var url = "/patchworks/".concat(patchworkId, "/custom/").concat(patchId, "/argument");
            return this.PatchworkAPI.patch(url, arg, false, { appId: appId });
        }
    };
    /**
     * Bulk updates x and y of the patches
     * @param patchworkId
     * @param batch should be {[patchId]: [x, y], ...}
     */
    PatchworkService.prototype.updatePatchCoordinates = function (patchworkId, batch) {
        var url = "/patchworks/".concat(patchworkId, "/patches/coordinates");
        return this.PatchworkAPI.put(url, batch);
    };
    PatchworkService.prototype.deletePatch = function (patchworkId, patchId) {
        var url = "/patchworks/".concat(patchworkId, "/patches/").concat(patchId);
        return this.PatchworkAPI.delete(url);
    };
    PatchworkService.prototype.bulkDeletePatches = function (patchworkId, patches) {
        var url = "/patchworks/".concat(patchworkId, "/patches");
        return this.PatchworkAPI.delete(url, patches);
    };
    PatchworkService.prototype.createEdge = function (patchworkId, edge) {
        var url = "/patchworks/".concat(patchworkId, "/edges");
        return this.PatchworkAPI.post(url, edge);
    };
    PatchworkService.prototype.updateEdge = function (patchworkId, edgeId, edge) {
        var url = "/patchworks/".concat(patchworkId, "/edges/").concat(edgeId);
        return this.PatchworkAPI.put(url, edge);
    };
    PatchworkService.prototype.deleteEdge = function (patchworkId, edgeId) {
        var url = "/patchworks/".concat(patchworkId, "/edges/").concat(edgeId);
        return this.PatchworkAPI.delete(url);
    };
    PatchworkService.prototype.createLogicPatchwork = function (appId, name) {
        var url = "/patchworks";
        return this.PatchworkAPI.post(url, {
            app: appId,
            type: 'logic',
            name: name !== null && name !== void 0 ? name : 'custom logic',
        });
    };
    PatchworkService.prototype.duplicateLogicPatchwork = function (patchworkId, duplicateId, name) {
        var url = "/patchworks/".concat(patchworkId, "/custom/insert");
        return this.PatchworkAPI.put(url, { app: duplicateId, name: name });
    };
    PatchworkService.prototype.getAllLogicPatchworks = function (appId) {
        var url = "/apps/".concat(appId, "/patchwork/logic");
        return this.PatchworkAPI.get(url);
    };
    // Patchwork permissions
    PatchworkService.prototype.readPatchworkPermissions = function (patchworkId) {
        var url = "/patchwork/".concat(patchworkId, "/access");
        return this.PatchworkAPI.get(url);
    };
    PatchworkService.prototype.updatePatchworkPermission = function (patchworkId, permissions) {
        var url = "/patchworks/".concat(patchworkId, "/access");
        return this.PatchworkAPI.put(url, permissions);
    };
    return PatchworkService;
}());
export { PatchworkService };
